/* import __COLOCATED_TEMPLATE__ from './no-collection-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();